import { Component, ElementRef, ViewChild } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { PersonOrganization } from '../model/personorganization';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orgswitcher',
  templateUrl: './orgswitcher.component.html',
  styleUrls: ['./orgswitcher.component.css']
})
export class OrgswitcherComponent {
  orglist: PersonOrganization[] = [];
  showOrgChooser: Subscription;
  @ViewChild("openorgselect", { static: false }) openorgselect: ElementRef;
  constructor( 
    private uievent: UieventhubService,
    private auth: AuthorizationService,
    private router: Router,
    private datastore: DatastoreService
  ) { 
    this.showOrgChooser = this.uievent.showOrgChooser$.pipe(untilDestroyed(this)).subscribe((show) => {
      //console.log("show org chooser",show);
      this.toggleOrgChooser(show);
    });

  }

  ngOnInit(): void {
    if (SessionHelper.getPersonOrgs()) {
      this.orglist = JSON.parse(SessionHelper.getPersonOrgs());
    }
  }
  toggleOrgChooser(show: boolean) {
    if (show) {
      this.openorgselect.nativeElement.click();
    }
  }
  orgClicked(org: PersonOrganization) {
    //this.norgyet = false;
    SessionHelper.setChoosenOrg(org.organizationId);
    this.uievent.setCurrentOrg(org.organizationId);
      //console.log(org);
      //this.auth.refreshPersonAuth(SessionHelper.getUserSub());
      this.datastore.clearData();
      this.router
        .navigateByUrl("/", { skipLocationChange: true })
        .then(() => this.router.navigate(["/portal"]));
   
  }

}
